import script from "./MobileNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./MobileNavbar.vue?vue&type=style&index=0&id=23876168&lang=scss"

const __exports__ = script;

export default __exports__